import { render, staticRenderFns } from "./JCAlarmInformation.vue?vue&type=template&id=1c581620&scoped=true&"
import script from "./JCAlarmInformation.vue?vue&type=script&lang=js&"
export * from "./JCAlarmInformation.vue?vue&type=script&lang=js&"
import style0 from "./JCAlarmInformation.vue?vue&type=style&index=0&id=1c581620&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c581620",
  null
  
)

export default component.exports